import { Link } from 'react-router-dom';
import './footer.css'
export default function Footer() {
    return <>
        <footer className="footer">
            <div className="footer-container">

                <div className="footer-logo">
                    <img src={`${process.env.PUBLIC_URL}/images/provencePaie_logo.png`} alt="Logo Provence Paie"/>
                </div>

                <div className="footer-info">
                    <h3>Provence Paie</h3>
                    <p>RESIDENCE LE MONTE CARLO,<br/> 355 BOULEVARD LEDRU ROLLIN, <br/>13300 SALON-DE-PROVENCE </p>
                    <i>Salon De Provence: <a href="tel:04 90 18 88 51">04 90 18 88 51</a></i>
                </div>
            </div>
            <div className="footer-bottom">
                <Link to="/mentions-legales">Mentions legales</Link>
            </div>
        </footer>
    </>
}
